export type LocationManagementLocationKind = {
  id: string;
  name: string;
};

export const defaultLocationManagementLocationKind: LocationManagementLocationKind = {
  id: "",
  name: "",
};
